<template>
  <div>
    <TitleField :fieldName="FieldName.MRPA_NOTARY_DOCUMENT" />
    <div class="row-box">
      <WrapperField
        v-for="(fieldValue, fieldName) in orderedData"
        :key="fieldValue + fieldName + Math.random()"
        :data="
          createDataField({
            fieldName,
            fieldValue,
            fieldGroup: FieldGroup.MRPA_NOTARY_DOCUMENT,
          })
        "
      />
    </div>
  </div>
</template>

<script>
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import { FieldName } from '@/constants';

const order = [
  'notaryJob',
  'notaryRegNumber',
  'notaryFirstName',
  'notaryLastName',
  'notaryPatronymic',
];

export default {
  name: 'MrpaNotaryDocument',
  props: ['data'],
  components: {
    WrapperField,
    TitleField,
  },
  data: () => ({
    FieldGroup,
    FieldName,
    createDataField,
  }),
  computed: {
    orderedData() {
      const res = {};

      order.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.data, key)) {
          res[key] = this.data[key];
        }
      });

      return res;
    },
  },
};
</script>
